import { Currency } from "@app/types/currencies";
import { RatesInfo } from "./types";

export const DEFAULT_RATE_INFO: RatesInfo = {
  rates: {
    [Currency.CHF]: 0,
    [Currency.EUR]: 0,
    [Currency.GBP]: 0,
    [Currency.USD]: 0,
  },
  timestamp: null,
  isError: false,
};

export const WEEKDAYS_MARKUP_RATE = 0.2;
export const WEEKEND_MARKUP_RATE = 0.5;
